import { isMobile } from '../helpers/isMobile';

export const applicationsId = {
  121: {
    production: '82',
    development: '129',
  },
};

export const gameNameById = {
  121: "pumpkinPayday",
};

export const matricesByGameId = {
  121: {
    WinningLinesCoordinate: [
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
    ],
    allLineMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    symbolsMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
  },
};

// RU: каждый следующий тир доигрывает цепочку предыдущего и добавляет свой переход и петлю.
//     MAX (коэффициент упёрся в maxOdd) своих maxStart/maxLoop в риге игры не имеет — играет ту же
//     epic-цепочку: прежде он ссылался на несуществующие анимации и попап открывался пустым.
const WIN_POPUP_CHAIN = [
  'bigStart',
  'bigLoop',
  'megaChange',
  'megaLoop',
  'superChange',
  'superLoop',
  'epicChange',
  'epicLoop',
];

// RU: пороги тиров и минимум показа — единые правила ядра (MG-49708: 10 / 20 / 50 / 100, max =
//     maxOdd, ниже 10× попапа нет), поэтому здесь не задаются; прежние свои 15 / 51 / 101 / 201 и
//     минимум 15 сняты, как у goldenTree. Цепочка режется ядром по `{tier}Loop`.
export const winPopupConfigs = {
  // RU: попап ставится затемнением ядра: у рига нет костей background/scale2 для вписывания.
  needBlackLayerComponent: true,
  popupPosition: {
    x: isMobile() ? 0 : 720,
    y: isMobile() ? 370 : 350,
  },
  // RU: сумма — bitmap-шрифтом игры (`fontPopup` в gameResources, гарнитура fontWildWeen).
  amountConfigs: {
    // RU: слот суммы в риге Big Win (winPopupsWeb/Mobile). Кость слота несёт scaleY −1, аттачмента
    //     нет — хост по умолчанию (контейнер слота).
    slot: 'bitMapNumbers',
    type: 'bitMap',
    x: 0,
    y: -10,
    fontChangeLimit: 8,
    pivot: 1,
    style: { fontName: 'fontWildWeen' },
    fontSizeBig: 80,
    fontSizeSmall: 80,
  },
  animationConfigs: {
    winPopupAnimation: [
      { type: 'BIG', duration: 3000, animationNames: WIN_POPUP_CHAIN.slice(0, 2) },
      { type: 'MEGA', duration: 5000, animationNames: WIN_POPUP_CHAIN.slice(0, 4) },
      { type: 'SUPER', duration: 7000, animationNames: WIN_POPUP_CHAIN.slice(0, 6) },
      { type: 'EPIC', duration: 9000, animationNames: WIN_POPUP_CHAIN.slice(0, 8) },
      { type: 'MAX', duration: 12000, animationNames: WIN_POPUP_CHAIN.slice(0, 8) },
    ],
  },
};
